export const users = [
  {
    id: 'user_luan',
    organizationId: 'org_3la_labs',
    name: 'Luan Cesar',
    email: 'luan@3lalabs.com.br',
    role: 'Administrador',
    lastAccess: '04/09/2026 14:32',
    status: 'Ativo',
  },
  {
    id: 'user_marina',
    organizationId: 'org_3la_labs',
    name: 'Marina Souza',
    email: 'marina@3lalabs.com.br',
    role: 'Financeiro',
    lastAccess: '04/09/2026 11:05',
    status: 'Ativo',
  },
  {
    id: 'user_pedro',
    organizationId: 'org_3la_labs',
    name: 'Pedro Almeida',
    email: 'pedro@3lalabs.com.br',
    role: 'Operacional',
    lastAccess: '03/09/2026 18:20',
    status: 'Ativo',
  },
  {
    id: 'user_ana',
    organizationId: 'org_3la_labs',
    name: 'Ana Ribeiro',
    email: 'ana@3lalabs.com.br',
    role: 'Visualização',
    lastAccess: '28/08/2026 09:14',
    status: 'Inativo',
  },
];

export const permissionModules = [
  'Dashboard',
  'Financeiro',
  'Clientes',
  'Fornecedores',
  'Produtos',
  'Contratos',
  'Fiscal',
  'Documentos',
  'Senhas',
  'Relatórios',
  'Configurações',
];

export const permissionActions = ['Visualizar', 'Criar', 'Editar', 'Excluir'];

export const rolePermissions = {
  Administrador: Object.fromEntries(
    [
      'Dashboard',
      'Financeiro',
      'Clientes',
      'Fornecedores',
      'Produtos',
      'Contratos',
      'Fiscal',
      'Documentos',
      'Senhas',
      'Relatórios',
      'Configurações',
    ].map((module) => [module, { Visualizar: true, Criar: true, Editar: true, Excluir: true }]),
  ),
  Financeiro: {
    Dashboard: { Visualizar: true, Criar: false, Editar: false, Excluir: false },
    Financeiro: { Visualizar: true, Criar: true, Editar: true, Excluir: false },
    Clientes: { Visualizar: true, Criar: true, Editar: true, Excluir: false },
    Fornecedores: { Visualizar: true, Criar: true, Editar: true, Excluir: false },
    Produtos: { Visualizar: true, Criar: false, Editar: false, Excluir: false },
    Contratos: { Visualizar: true, Criar: true, Editar: true, Excluir: false },
    Fiscal: { Visualizar: true, Criar: true, Editar: true, Excluir: false },
    Documentos: { Visualizar: true, Criar: true, Editar: false, Excluir: false },
    Senhas: { Visualizar: false, Criar: false, Editar: false, Excluir: false },
    Relatórios: { Visualizar: true, Criar: true, Editar: false, Excluir: false },
    Configurações: { Visualizar: true, Criar: false, Editar: false, Excluir: false },
  },
  Operacional: {
    Dashboard: { Visualizar: true, Criar: false, Editar: false, Excluir: false },
    Financeiro: { Visualizar: true, Criar: false, Editar: false, Excluir: false },
    Clientes: { Visualizar: true, Criar: true, Editar: true, Excluir: false },
    Fornecedores: { Visualizar: true, Criar: true, Editar: true, Excluir: false },
    Produtos: { Visualizar: true, Criar: true, Editar: true, Excluir: false },
    Contratos: { Visualizar: true, Criar: true, Editar: true, Excluir: false },
    Fiscal: { Visualizar: true, Criar: true, Editar: false, Excluir: false },
    Documentos: { Visualizar: true, Criar: true, Editar: true, Excluir: false },
    Senhas: { Visualizar: true, Criar: false, Editar: false, Excluir: false },
    Relatórios: { Visualizar: true, Criar: false, Editar: false, Excluir: false },
    Configurações: { Visualizar: false, Criar: false, Editar: false, Excluir: false },
  },
  Visualização: Object.fromEntries(
    [
      'Dashboard',
      'Financeiro',
      'Clientes',
      'Fornecedores',
      'Produtos',
      'Contratos',
      'Fiscal',
      'Documentos',
      'Senhas',
      'Relatórios',
      'Configurações',
    ].map((module) => [
      module,
      {
        Visualizar: module !== 'Senhas' && module !== 'Configurações',
        Criar: false,
        Editar: false,
        Excluir: false,
      },
    ]),
  ),
};
